import {httpModel} from '../../http/httpModel'
import moment from 'moment'
const loginModule = {
  state: {
  },
  mutations: {
    // setOrgId: (state, id) => {
    //   state.orgId = id
    // },
    // setBoxInfo: (state, info) => {
    //   console.log(info)
    //   state.boxInfo = info
    // }
  },
  actions: {
    // 刷新token
    doRefreshToken: ({state, commit, rootState}, token) => {
      // console.log(token)
      httpModel.refreshToken(token).then((res) => {
        // console.log(res)
        if (res.autoRefresh) {
          let expire = parseInt(res.expiration) / 2 + moment().unix()
          // console.log(expire)
          commit('SET_TOKEN', {
            token: res.token,
            expire
          })
        } else {
          commit('SET_TOKEN', {
            token: res.token
          })
        }
        
      })
      // commit('setOrgId', payload)
    },
  }
}

export default loginModule